import React from 'react';
import { ACTIVE_PROMO } from '../data/clinicalPlans.js';

/**
 * Shared promo callout for the current sitewide discount code — rendered on both marketing
 * pricing sections and the checkout modal so the code/copy can't drift between them (same
 * "one source of truth" pattern as CLINICALS_PLANS_MONTHLY). Disappears on its own once
 * ACTIVE_PROMO.expires passes, so nobody lands on a dead code after the promo window ends.
 */
const PromoBanner = ({ className = '' }) => {
    if (!ACTIVE_PROMO || new Date() > new Date(ACTIVE_PROMO.expires)) return null;
    return (
        <div className={`flex items-center justify-center gap-2.5 rounded-xl border border-teal-400/30 bg-teal-500/10 px-4 py-2.5 text-center ${className}`}>
            <span className="text-base leading-none">🎉</span>
            <p className="text-sm text-teal-200">
                <span className="font-semibold text-white">{ACTIVE_PROMO.headline}</span>
                {' — '}
                <span className="text-teal-300">
                    code <span className="font-mono font-semibold tracking-wide">{ACTIVE_PROMO.code}</span>
                </span>
                <span className="hidden sm:inline text-teal-400/80"> · new subscribers only</span>
            </p>
        </div>
    );
};

export default PromoBanner;
